import { Link } from "@/components/Link";
import { SingleColumn } from "@/layouts/single-column";

type FaqItem = {
  question: string;
  answer: React.ReactNode;
};

const faqItems: FaqItem[] = [
  {
    question: "How to verify for custom and/or cash dreams?",
    answer: (
      <>
        <p className="text-base-content/80">
          1. To get verified for Cash Gifts successfully receive 5 items from the{" "}
          <Link to="/market" className="link link-primary">
            Marketplace
          </Link>
          .
        </p>
        <p className="text-base-content/80">
          2. To get verified for Custom Links successfully receive 10 items from the{" "}
          <Link to="/market" className="link link-primary">
            Marketplace
          </Link>
        </p>
        <p className="text-base-content/80 mt-2">
          * Please check the{" "}
          <Link to="/brands/f57af135-9c08-47db-9105-985f398267cb" className="link link-primary">
            Services
          </Link>{" "}
          tab in Marketplace for our current cash offerings
        </p>
      </>
    ),
  },
  {
    question: "What is DreamVault?",
    answer: (
      <p className="text-base-content/80">
        DreamVault is the place where dreams take flight. It's a platform designed to connect people and bring
        incredible ideas to life. Whether you're seeking funding, unique items, or the tools to create something
        special, DreamVault is your one-stop dream factory.
      </p>
    ),
  },
  {
    question: "What are Dreams and Dream Collections?",
    answer: (
      <p className="text-base-content/80">
        A <span className="font-bold">Dream</span> is a single project or idea that a Dreamer wants to make a reality.
        It could be a product, a creative endeavor, a charity event, a baby shower, or anything else you can imagine.{" "}
        <br className="my-2" />A <span className="font-bold">Dream Collection</span> is a curated gallery of Dreams.
        They tell a story, showcasing a Dreamer's full vision and the diverse ways they're making their dreams a
        reality.
      </p>
    ),
  },
  {
    question: "How do I support Dreamers?",
    answer: (
      <p className="text-base-content/80">
        To support Dreamers, browse their Dream Collection, select the items you'd like to purchase, and follow the
        checkout process. Your support will mean the world to them!
      </p>
    ),
  },
  {
    question: "What types of Dreams can I find on DreamVault?",
    answer: (
      <p className="text-base-content/80">
        DreamVault is a universe of possibilities, where you can discover all kinds of dreams. <br />
        <br />
        <span className="font-bold">Marketplace Dreams</span>: Explore millions of items from our hand-picked stores -
        everything from the everyday to the extraordinary.
        <br />
        <span className="font-bold">Cash Dreams</span>: Need some funds to make your dream happen? Tell the DreamVault
        community your story and ask for direct financial support.
        <br />
        <span className="font-bold">Custom DreamLinks</span>: Have a favorite online store or a specific item in mind?
        Turn any web link into a Dream and share it with the DreamVault community!
        <br />
        <span className="font-bold">Crowdfunding</span>: For bigger visions and ambitious projects, Dreamers can launch
        crowdfunding campaigns to raise funds and gather support from a community of like-minded dreamers.
      </p>
    ),
  },
  {
    question: "What can I expect from the DreamVault community?",
    answer: (
      <p className="text-base-content/80">
        DreamVault is more than just a platform - it's a community of dreamers! Share your thoughts, feedback, and
        encouragement directly on Dream and Dream Collection pages. Build connections and inspire others with your
        words. You may also connect privately with Dreamers to discuss collaborations, ask questions, or simply share
        your enthusiasm for a project. DreamVault is all about fostering a vibrant community where dreams are nurtured
        and realized. Join the community!
      </p>
    ),
  },
  {
    question: "What are Stickers?",
    answer: (
      <p className="text-base-content/80">
        Stickers are fun ways to show your support for Dreamers. Purchase packs of unique stickers to add to a Dreamer's
        profile picture. It's a fun way to show your love for their projects and give them a boost! Share stickers and
        make your mark on the DreamVault community!
      </p>
    ),
  },
  {
    question: "Is DreamVault free to use?",
    answer: (
      <p className="text-base-content/80">
        Joining DreamVault is free to use! We have a fixed fee for every transaction. Check it out on our Terms of
        Service.
      </p>
    ),
  },
  {
    question: "How do I report a Dreamer?",
    answer: (
      <p className="text-base-content/80">
        We strive to create a positive and safe environment for everyone. If you encounter any abusive behavior, hate
        speech, or explicit content, please contact us immediately.
      </p>
    ),
  },
  {
    question: "What is our policy on inappropriate content?",
    answer: (
      <p className="text-base-content/80">
        We are committed to maintaining a safe and welcoming environment for all users. As such, we prohibit any content
        that is sexually suggestive, exploits, abuses, or endangers children, or promotes violence or hate speech.
      </p>
    ),
  },
  {
    question: "What do I do if I find a bug?",
    answer: (
      <p className="text-base-content/80">
        We're constantly working to make DreamVault a better experience. If you come across a technical glitch, please
        don't hesitate to contact us.
      </p>
    ),
  },
];

export default function Faq() {
  return (
    <SingleColumn.Root>
      <SingleColumn.Main>
        <div className="card bg-base-100 p-6">
          <h2 className="text-3xl font-bold mb-8">Frequently Asked Questions</h2>

          <div className="space-y-4">
            {faqItems.map((item, index) => (
              <div
                key={index}
                className="collapse collapse-plus bg-base-100 rounded-lg border border-base-200 hover:border-base-300"
              >
                <input type="checkbox" />
                <div className="collapse-title text-lg font-medium py-4">{item.question}</div>
                <div className="collapse-content">{item.answer}</div>
              </div>
            ))}
          </div>
        </div>
      </SingleColumn.Main>
    </SingleColumn.Root>
  );
}
